import React, { useState, useEffect } from 'react';
import { Api_Endpoints } from '../../Api/apiEndpoint';
import { makeApiCall } from '../../Api/makeApiCall';
import { showErrorToast, showSuccessToast } from '../../utils/toastService';
import './InvoiceViewPage.css';
import { useLocation, useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';
import FileUpload from '../../components/ui/CustomFileUpload';
import { Eye } from 'lucide-react';
import CurrencyFormat from 'react-currency-format';
import ImageModal from "./ImageModal.jsx";
import { CheckCircle, XCircle, Clock } from 'lucide-react';
import { getUserSession } from "../../utils/auth";
import formatAmount from '../../utils/formaAmount.js';
import CommentModal from '../VendorViewPage/CommentModal';
import * as helper from "../../service/helper.js"
export const InvoiceViewPage = () => {
  const data = useLocation();
  const navigate = useNavigate();
  const user_data = getUserSession();
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [comment, setComment] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const InvoiceID = data?.state?.InvoiceID;
  const vendorID = data?.state?.VendorID;


  const handleConfirmAction = async () => {
    const actionData = {
      invoice_id: InvoiceID,
      invoice_attachment1_approved: invoiceDetails.invoice_attachment1_approved || null,
      invoice_attachment2_approved: invoiceDetails.invoice_attachment2_approved || null,
      invoice_attachment3_approved: invoiceDetails.invoice_attachment3_approved || null,
      type: user_data?.user,
      total_amount: invoiceDetails?.total,
      payment_mode: 'Online',
      comments: comment,
      action: status,
      department: invoiceDetails.department,
      department_data: invoiceDetails.department_data,
    };

    // Add validation to ensure required fields are present
    if (!actionData.invoice_id || !actionData.action) {
      showErrorToast('Required fields are missing');
      return;
    }

    const response = await makeApiCall(Api_Endpoints.INVOICE_ACTION, 'POST', actionData);
    if (response?.result.status) {
      showSuccessToast(response?.message);
      GetInvoiceDetails();
      setShowConfirmation(false);
      navigate('/InvoiceList')
      setCommentModalOpen(false);
    } else {
      showErrorToast(response?.message);
      setShowConfirmation(false)
    }
  };
  const [VendorDropdown, setVendorDropDown] = useState({})
  const [InvoiceDropDown, setInvoiceDropDown] = useState({})
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [authorizedPersonOptions, setAuthorizedPersonOptions] = useState([]);
  const [filteredAuthorizedPersons, setFilteredAuthorizedPersons] = useState([]);
  const [showApproval, setShowApproval] = useState();
  const [attachmentStatus, setAttachmentStatus] = useState({
    attachment1: false,
    attachment2: false,
    attachment3: false,
  });

  const [attachmentFiles, setAttachmentFiles] = useState({
    attachment1: null,
    attachment2: null,
    attachment3: null
  });

  const [showInstallmentTransaction, setShowInstallmentTransaction] = useState({
    firstTransaction: false,
    secondTransaction: false,
    thirdTransaction: false
  });

  const [invoiceDetails, setInvoiceDetails] = useState("");
  const [vendorDetails, setVendorDetails] = useState({});
  const [status, setstatus] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationType, setConfirmationType] = useState('');
  const [getDocument, setGetDocument] = useState("");
  const [ApprovedDoc, setApprovedDoc] = useState("")
  const [count, setCount] = useState(true)
  const handleActionClick = (adminComment) => {
    setShowConfirmation(true);
    setComment(adminComment)
    // setstatus(actionType === 'APPROVED' ? 'APPROVED' : 'REFER-BACK');

  };

  const handleModal = (action) => {
    setCommentModalOpen(true)
    setstatus(action)
  }

  const handleFileChange = (file, attachmentKey) => {
    if (file) {

      setAttachmentFiles(prev => ({
        ...prev,
        [attachmentKey]: file
      }));

      setInvoiceDetails(prev => ({
        ...prev,
        [attachmentKey]: file.name || ''
      }));
    }
  };



  const checkAllDocumentsStatus = () => {
    // Initialize an object to store Approved statuses
    const ApprovedStatuses = {};

    // Ensure documentStatuses is available and is an object
    if (documentStatuses && typeof documentStatuses === "object") {
      // Iterate over documentStatuses and filter out only "Approved" statuses
      Object.entries(documentStatuses).forEach(([key, value]) => {
        if (value === "APPROVED") {
          ApprovedStatuses[key] = value;  // Add to ApprovedStatuses
        }
      });

      // Update state with Approved documents
      setApprovedDoc(Object.keys(ApprovedStatuses).length, "approvvhebhbd lenght");
    }

    // Return only the ApprovedStatuses object
    return ApprovedStatuses;
  };


  const handleInvoiceCompanyChange = (newCompany) => {
    setInvoiceDetails((prev) => ({
      ...prev,
      invoicing_company: newCompany,
    }));
  };

  // const handleDepartmentChange = (value) => {
  //   setInvoiceDetails((prev) => ({
  //     ...prev,
  //     department: value,
  //     // department_data: ''
  //   }));

  //   const filteredPersons = authorizedPersonOptions.filter(person => person.key === value);

    
  //   setFilteredAuthorizedPersons(filteredPersons);

  // };

  const handleDepartmentChange = (value) => {
    setInvoiceDetails((prev) => ({
      ...prev,
      department: value,
      // Remove the line that resets department_data
      // department_data: ''
    }));

    const filteredPersons = authorizedPersonOptions.filter(person => person.key === value);
    
    setFilteredAuthorizedPersons(filteredPersons);
    
    // If there's only one authorized person, automatically select it
    if (filteredPersons.length === 1) {
      setInvoiceDetails(prev => ({
        ...prev,
        department_data: filteredPersons[0].value
      }));
    } else {
      // Reset department_data if multiple options exist
      setInvoiceDetails(prev => ({
        ...prev,
        department_data: ''
      }));
    }
};

  const handleAuthorizedPersonChange = (value) => {
    console.log(value, '7878789')
    setInvoiceDetails(prev => ({
      ...prev,
      department_data: value
    }));
  };
  const handleInvoicePaymentModeChange = (changeMode) => {
    setInvoiceDetails((prev) => ({
      ...prev,
      payment_mode: changeMode,
    }));
  };

  const safeParseFloat = (value) => {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  const isIntraStateGST = (gstNumber) => {
    if (!gstNumber || typeof gstNumber !== 'string') {
      console.log('Invalid GST number:', gstNumber);
      return false;
    }
    const stateCode = gstNumber.substring(0, 2);
    return stateCode === "27"; // Maharashtra state code
  };

  const calculateAmounts = (netAmount, gstNumber, gst_rate = 0, tds_rate = 0) => {
    const net_amt = safeParseFloat(netAmount);
    const gstRate = safeParseFloat(gst_rate.toString().replace('%', ''));
    const tdsRate = safeParseFloat(tds_rate.toString().replace('%', ''));

    if (net_amt <= 0) {
      return;
    }

    let igst = 0;
    let cgst = 0;
    let sgst = 0;
    const isIntraState = isIntraStateGST(gstNumber);
    if (isIntraState) {
      const halfGstRate = gstRate / 2;
      cgst = (net_amt * halfGstRate) / 100;
      sgst = (net_amt * halfGstRate) / 100;
    } else {
      igst = (net_amt * gstRate) / 100;
    }

    const gst_amount = igst + cgst + sgst;
    const tds_amt = (net_amt * tdsRate) / 100;
    const total = net_amt + gst_amount;
    const net_payable = total - tds_amt;

    setInvoiceDetails(prev => ({
      ...prev,
      net_amt: net_amt,
      igst: igst.toFixed(2),
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      gst_amount: gst_amount.toFixed(2),
      total: total.toFixed(2),
      tds_amt: tds_amt.toFixed(2),
      net_payable: net_payable.toFixed(2),
      gst_rate: gstRate + '%',
      tds_rate: tdsRate + '%',
    }));
  };

  const handleNetAmountChange = (e) => {
    const netAmount = e.target.value;
    setInvoiceDetails((prev) => ({
      ...prev,
      net_amt: netAmount,
    }));

    calculateAmounts(
      netAmount,
      invoiceDetails?.gst_no,
      invoiceDetails?.gst_rate ? `${invoiceDetails.gst_rate}%` : '0.00',
      invoiceDetails?.tds_rate ? `${invoiceDetails.tds_rate}%` : '0.00',
    );
  };

  const getMonthNumber = (monthName) => {
    const months = {
      'January': '01', 'Jan': '01',
      'February': '02', 'Feb': '02',
      'March': '03', 'Mar': '03',
      'April': '04', 'Apr': '04',
      'May': '05',
      'June': '06', 'Jun': '06',
      'July': '07', 'Jul': '07',
      'August': '08', 'Aug': '08',
      'September': '09', 'Sep': '09',
      'October': '10', 'Oct': '10',
      'November': '11', 'Nov': '11',
      'December': '12', 'Dec': '12'
    };
    return months[monthName] || '01';
  };

  const formatMonthValue = () => {
    if (!invoiceDetails?.business_month) return '';
    const [monthName, year] = invoiceDetails.business_month.split(' ');
    const monthNum = getMonthNumber(monthName);
    const finalYear = year || new Date().getFullYear();
    return `${finalYear}-${monthNum}`;
  };


  const isEditable = user_data?.user === 'Account';
  const [submittedPayments, setSubmittedPayments] = useState({
    payment: false,
    first: false,
    second: false,
    third: false
  });
  const [paymentFormValues, setPaymentFormValues] = useState({});

  const handleInputChange = (field, value) => {
    console.log(field, value);
    if (field === 'business_month') {
      // const monthNum = value.split('-')[1];
      const [year, monthNum] = value.split('-');
      const months = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'];
      const monthName = months[parseInt(monthNum) - 1];
      const fullMonthYear = `${monthName} ${year}`;

      setInvoiceDetails(prev => ({
        ...prev,
        business_month: fullMonthYear,
        // business_year: year
      }));
    } else if (field.includes('payment_') || field.includes('transaction_')) {

      if (field.includes('_amt')) {
        const totalAmount = parseFloat(invoiceDetails.total || 0);

        // Calculate total of all payments including the new value
        const newTotal = (
          parseFloat(field === 'payment_amt' ? value : paymentFormValues.payment_amt || invoiceDetails.payment_amt || 0) +
          parseFloat(field === 'first_transaction_amt' ? value : paymentFormValues.first_transaction_amt || invoiceDetails.first_transaction_amt || 0) +
          parseFloat(field === 'second_transaction_amt' ? value : paymentFormValues.second_transaction_amt || invoiceDetails.second_transaction_amt || 0) +
          parseFloat(field === 'third_transaction_amt' ? value : paymentFormValues.third_transaction_amt || invoiceDetails.third_transaction_amt || 0)
        );

        if (newTotal > totalAmount) {
          showErrorToast('Total payments cannot exceed invoice amount');
          return;
        }
      }

      // Update temporary form values for payment fields
      setPaymentFormValues(prev => ({
        ...prev,
        [field]: value
      }));
    } else {
      setInvoiceDetails(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  const handlePaymentSubmit = async () => {
    try {

      if (user_data?.user !== 'Finance') {
        if (!attachmentFiles.url_attachment1) {
          showErrorToast('Please upload Attachment Document 1. It is mandatory.');
          setFormErrors(prev => ({
            ...prev,
            url_attachment1: 'This document is required'
          }));
          return;
        }
      }

      const totalAmount = parseFloat(invoiceDetails.total || 0);
      const balanceAmount = parseFloat(invoiceDetails?.balance_amt || totalAmount || 0);

      const submittedPaymentTotal = (
        parseFloat(paymentFormValues.payment_amt || invoiceDetails.payment_amt || 0) +
        parseFloat(paymentFormValues.first_transaction_amt || invoiceDetails.first_transaction_amt || 0) +
        parseFloat(paymentFormValues.second_transaction_amt || invoiceDetails.second_transaction_amt || 0) +
        parseFloat(paymentFormValues.third_transaction_amt || invoiceDetails.third_transaction_amt || 0)
      );

      if (submittedPaymentTotal > totalAmount) {
        showErrorToast('Total payments cannot exceed invoice amount');
        return;
      }
      setInvoiceDetails(prev => ({
        ...prev,
        department_data: invoiceDetails.department_data || vendorDetails.department_data || ''
      }));
      // Build base payload with payment form values first
      const payload = {
        invoice_id: InvoiceID,
        vendor_id: invoiceDetails.vendor_id || vendorDetails.vendor_id || vendorID,
        invoicing_company: 'Indicosmic Infotech Ltd',
        business_month: invoiceDetails.business_month,
        business_year: invoiceDetails.business_year,
        name: invoiceDetails.name || vendorDetails.name || '',
        gst_no: invoiceDetails.gst_no || vendorDetails.gst_no || '',
        pan_no: invoiceDetails.pan_no || vendorDetails.pan_no || '',
        invoice_date: invoiceDetails.invoice_date,
        invoice_number: invoiceDetails.invoice_number,
        nature_of_business: invoiceDetails.nature_of_business || vendorDetails.nature_of_business,
        net_amt: parseFloat(invoiceDetails.net_amt) || 0,
        gst_rate: parseFloat(invoiceDetails.gst_rate) || parseFloat(vendorDetails.gst_rate) || 0,
        gst_amount: parseFloat(invoiceDetails.gst_amount) || 0,
        igst: parseFloat(invoiceDetails.igst) || 0,
        cgst: parseFloat(invoiceDetails.cgst) || 0,
        sgst: parseFloat(invoiceDetails.sgst) || 0,
        total: parseFloat(invoiceDetails.total) || 0,
        tds_rate: parseFloat(invoiceDetails.tds_rate) || parseFloat(vendorDetails.tds_rate) || 0,
        tds_amt: parseFloat(invoiceDetails.tds_amt) || 0,
        net_of_tds: parseFloat(invoiceDetails.net_payable) || 0,
        net_payable: parseFloat(invoiceDetails.net_payable) || 0,
        payment_mode: 'Online' || '',
        department: invoiceDetails.department,
        department_data: invoiceDetails.department_data,
        // department_data: invoiceDetails.department_data || vendorDetails.department_data || '',
        invoice_attachment1: attachmentFiles.url_attachment1 || '',
        invoice_attachment2: attachmentFiles.url_attachment2 || '',
        invoice_attachment3: attachmentFiles.url_attachment3 || '',
        // Payment and transaction fields - prioritize form values over invoice details
        payment_amt: paymentFormValues.payment_amt || invoiceDetails.payment_amt || 0,
        payment_date: paymentFormValues.payment_date || invoiceDetails.payment_date || null,
        payment_utr: paymentFormValues.payment_utr || invoiceDetails.payment_utr || null,

        first_transaction_amt: paymentFormValues.first_transaction_amt || invoiceDetails.first_transaction_amt || 0,
        first_transaction_date: paymentFormValues.first_transaction_date || invoiceDetails.first_transaction_date || null,
        first_transaction_utr: paymentFormValues.first_transaction_utr || invoiceDetails.first_transaction_utr || null,

        second_transaction_amt: paymentFormValues.second_transaction_amt || invoiceDetails.second_transaction_amt || 0,
        second_transaction_date: paymentFormValues.second_transaction_date || invoiceDetails.second_transaction_date || null,
        second_transaction_utr: paymentFormValues.second_transaction_utr || invoiceDetails.second_transaction_utr || null,

        third_transaction_amt: paymentFormValues.third_transaction_amt || invoiceDetails.third_transaction_amt || 0,
        third_transaction_date: paymentFormValues.third_transaction_date || invoiceDetails.third_transaction_date || null,
        third_transaction_utr: paymentFormValues.third_transaction_utr || invoiceDetails.third_transaction_utr || null
      };

      // Remove the conditional overwriting section that was causing the issue
      // The form values are now properly prioritized in the payload construction above

      const response = await makeApiCall(Api_Endpoints.INVOICE_ADD, 'POST', payload);

      if (response?.status) {
        showSuccessToast('Payment details updated successfully');
        GetInvoiceDetails();
      } else {
        showErrorToast(response?.message || 'Failed to update payment details');
      }
    } catch (error) {
      console.error('Error updating payment:', error);
      showErrorToast('An error occurred while updating payment details');
    }
  };
  const isPaymentValid = (payment) => {
    return payment.amt && payment.date && payment.utr;
  };



  const isUpdateButtonDisabled = () => {
    // Check if any payment section is being filled
    const mainPaymentFilled = paymentFormValues.payment_amt &&
      paymentFormValues.payment_date &&
      paymentFormValues.payment_utr;

    const firstTransactionFilled = paymentFormValues.first_transaction_amt &&
      paymentFormValues.first_transaction_date &&
      paymentFormValues.first_transaction_utr;

    const secondTransactionFilled = paymentFormValues.second_transaction_amt &&
      paymentFormValues.second_transaction_date &&
      paymentFormValues.second_transaction_utr;

    const thirdTransactionFilled = paymentFormValues.third_transaction_amt &&
      paymentFormValues.third_transaction_date &&
      paymentFormValues.third_transaction_utr;

    // Function to check if a transaction is partially filled
    const isPartiallyFilled = (amt, date, utr) => {
      return !!(amt || date || utr);
    };

    // Check for partially filled transactions
    const mainPaymentPartial = isPartiallyFilled(
      paymentFormValues.payment_amt,
      paymentFormValues.payment_date,
      paymentFormValues.payment_utr
    );

    const firstTransactionPartial = isPartiallyFilled(
      paymentFormValues.first_transaction_amt,
      paymentFormValues.first_transaction_date,
      paymentFormValues.first_transaction_utr
    );

    const secondTransactionPartial = isPartiallyFilled(
      paymentFormValues.second_transaction_amt,
      paymentFormValues.second_transaction_date,
      paymentFormValues.second_transaction_utr
    );

    const thirdTransactionPartial = isPartiallyFilled(
      paymentFormValues.third_transaction_amt,
      paymentFormValues.third_transaction_date,
      paymentFormValues.third_transaction_utr
    );

    // Button should be disabled if any transaction is partially filled but not complete
    const hasPartialTransaction = (mainPaymentPartial && !mainPaymentFilled) ||
      (firstTransactionPartial && !firstTransactionFilled) ||
      (secondTransactionPartial && !secondTransactionFilled) ||
      (thirdTransactionPartial && !thirdTransactionFilled);

    // Button should be enabled if at least one transaction is completely filled
    const hasCompleteTransaction = mainPaymentFilled ||
      firstTransactionFilled ||
      secondTransactionFilled ||
      thirdTransactionFilled;

    // Disable button if there are partial transactions or no complete transactions
    return hasPartialTransaction || !hasCompleteTransaction;
  };
  const renderPaymentSection = () => {
    if (user_data?.user !== 'Finance') return null;

    const totalAmount = parseFloat(invoiceDetails?.total || 0);
    const balanceAmount = parseFloat(invoiceDetails?.balance_amt || totalAmount || 0);
    const isFullyPaid = balanceAmount <= 0;

    // Helper function to check if a field should be editable based on API response values
    const isFieldEditable = (value, date, utr) => {
      // Check against the last successfully submitted values from the API
      const normalizedValue = value ? parseFloat(value) : 0;
      const dateIsEmpty = !date || date === 'null';
      const utrIsEmpty = !utr || utr === '0' || utr === 'null';
      return normalizedValue === 0 && (dateIsEmpty || date === null) && utrIsEmpty;
    };

    // Calculate payment totals from API response values
    const paymentAmount = parseFloat(invoiceDetails?.payment_amt || 0);
    const firstTransAmount = parseFloat(invoiceDetails?.first_transaction_amt || 0);
    const secondTransAmount = parseFloat(invoiceDetails?.second_transaction_amt || 0);
    const thirdTransAmount = parseFloat(invoiceDetails?.third_transaction_amt || 0);

    // Determine which sections to show based on API response values
    const showFirstTransaction = true; // Always show first transaction if there's a payment
    const showSecondTransaction = balanceAmount > 0 && (paymentAmount > 0 || firstTransAmount > 0);
    const showThirdTransaction = balanceAmount > 0 && secondTransAmount > 0;

    // Check editability based on API response values, not current input values
    const mainPaymentEditable = isFieldEditable(
      invoiceDetails?.payment_amt,
      invoiceDetails?.payment_date,
      invoiceDetails?.payment_utr
    );

    const firstTransactionEditable = isFieldEditable(
      invoiceDetails?.first_transaction_amt,
      invoiceDetails?.first_transaction_date,
      invoiceDetails?.first_transaction_utr
    );

    const secondTransactionEditable = isFieldEditable(
      invoiceDetails?.second_transaction_amt,
      invoiceDetails?.second_transaction_date,
      invoiceDetails?.second_transaction_utr
    );

    const thirdTransactionEditable = isFieldEditable(
      invoiceDetails?.third_transaction_amt,
      invoiceDetails?.third_transaction_date,
      invoiceDetails?.third_transaction_utr
    );

    return (
      <>
        <h2 className="invoice-subtitle">Payment Details</h2>
        <div className="invoice-section">
          <table className="invoice-table">
            <tbody>
              <tr>
                <td><strong>Total Invoice Value</strong></td>
                <td>
                  <CurrencyFormat
                    value={totalAmount}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </td>
                <td><strong>Balance Amount</strong></td>
                <td>
                  <CurrencyFormat
                    value={balanceAmount}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </td>
              </tr>
              <tr>
                <td><strong>Payment Status</strong></td>
                <td>{invoiceDetails?.payment_status?.toUpperCase() || 'PENDING'}</td>
              </tr>

              {/* Main Payment Section */}
              <tr>
                <td><strong>Payment Amount</strong></td>
                <td>
                  <CurrencyFormat
                    value={paymentFormValues.payment_amt ?? invoiceDetails?.payment_amt ?? ''}
                    onValueChange={(values) => {
                      const { floatValue } = values;
                      if (floatValue > balanceAmount) {
                        showErrorToast("Amount cannot exceed balance");
                        handleInputChange('payment_amt', balanceAmount);
                      } else {
                        handleInputChange('payment_amt', floatValue || '');
                      }
                    }}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    disabled={!mainPaymentEditable}
                    className="input-box"
                  />
                </td>
                <td><strong>Payment Date</strong></td>
                <td>
                  <input
                    type="date"
                    value={paymentFormValues.payment_date ?? invoiceDetails?.payment_date ?? ''}
                    onChange={(e) => handleInputChange('payment_date', e.target.value)}
                    disabled={!mainPaymentEditable}
                    className="input-box"
                  />
                </td>
              </tr>
              <tr>
                <td><strong>Payment UTR</strong></td>
                <td>
                  <input
                    type="text"
                    value={paymentFormValues.payment_utr ?? invoiceDetails?.payment_utr ?? ''}
                    onChange={(e) => handleInputChange('payment_utr', e.target.value)}
                    disabled={!mainPaymentEditable}
                    className="input-box"
                  />
                </td>
              </tr>

              {/* First Transaction Section */}
              {(firstTransAmount > 0 || (balanceAmount > 0 && paymentAmount > 0)) && (
                <>
                  <tr>
                    <td><strong>First Payment Amount</strong></td>
                    <td>
                      <CurrencyFormat
                        value={paymentFormValues.first_transaction_amt ?? invoiceDetails?.first_transaction_amt ?? ''}
                        onValueChange={(values) => {
                          const { floatValue } = values;
                          if (floatValue > balanceAmount) {
                            showErrorToast("Amount cannot exceed balance");
                            handleInputChange('first_transaction_amt', balanceAmount);
                          } else {
                            handleInputChange('first_transaction_amt', floatValue || '');
                          }

                        }}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        disabled={!firstTransactionEditable}
                        className="input-box"
                      />
                    </td>
                    <td><strong>Payment Date</strong></td>
                    <td>
                      <input
                        type="date"
                        value={paymentFormValues.first_transaction_date ?? invoiceDetails?.first_transaction_date ?? ''}
                        onChange={(e) => handleInputChange('first_transaction_date', e.target.value)}
                        disabled={!firstTransactionEditable}
                        className="input-box"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Payment UTR</strong></td>
                    <td>
                      <input
                        type="text"
                        value={paymentFormValues.first_transaction_utr ?? invoiceDetails?.first_transaction_utr ?? ''}
                        onChange={(e) => handleInputChange('first_transaction_utr', e.target.value)}
                        disabled={!firstTransactionEditable}
                        className="input-box"
                      />
                    </td>
                  </tr>
                </>
              )}

              {/* Second Transaction Section */}
              {(secondTransAmount > 0 || (balanceAmount > 0 && firstTransAmount > 0)) && (
                <>
                  <tr>
                    <td><strong>Second Payment Amount</strong></td>
                    <td>
                      <CurrencyFormat
                        value={paymentFormValues.second_transaction_amt ?? invoiceDetails?.second_transaction_amt ?? ''}
                        onValueChange={(values) => {
                          const { floatValue } = values;
                          if (floatValue > balanceAmount) {
                            showErrorToast("Amount cannot exceed balance");
                            handleInputChange('second_transaction_amt', balanceAmount);
                          } else {
                            handleInputChange('second_transaction_amt', floatValue || '');
                          }

                        }}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        disabled={!secondTransactionEditable}
                        className="input-box"
                      />
                    </td>
                    <td><strong>Payment Date</strong></td>
                    <td>
                      <input
                        type="date"
                        value={paymentFormValues.second_transaction_date ?? invoiceDetails?.second_transaction_date ?? ''}
                        onChange={(e) => handleInputChange('second_transaction_date', e.target.value)}
                        disabled={!secondTransactionEditable}
                        className="input-box"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Payment UTR</strong></td>
                    <td>
                      <input
                        type="text"
                        value={paymentFormValues.second_transaction_utr ?? invoiceDetails?.second_transaction_utr ?? ''}
                        onChange={(e) => handleInputChange('second_transaction_utr', e.target.value)}
                        disabled={!secondTransactionEditable}
                        className="input-box"
                      />
                    </td>
                  </tr>
                </>
              )}

              {/* Third Transaction Section */}
              {(thirdTransAmount > 0 || (balanceAmount > 0 && secondTransAmount > 0)) && (
                <>
                  <tr>
                    <td><strong>Final Payment Amount</strong></td>
                    <td>
                      <CurrencyFormat
                        value={paymentFormValues.third_transaction_amt ?? invoiceDetails?.third_transaction_amt ?? ''}
                        onValueChange={(values) => {
                          const { floatValue } = values;
                          if (floatValue > balanceAmount) {
                            showErrorToast("Amount cannot exceed balance");
                            handleInputChange('third_transaction_amt', balanceAmount);
                          } else {

                          }
                          handleInputChange('third_transaction_amt', floatValue || '');
                        }}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        disabled={!thirdTransactionEditable}
                        className="input-box"
                      />
                    </td>
                    <td><strong>Payment Date</strong></td>
                    <td>
                      <input
                        type="date"
                        value={paymentFormValues.third_transaction_date ?? invoiceDetails?.third_transaction_date ?? ''}
                        onChange={(e) => handleInputChange('third_transaction_date', e.target.value)}
                        disabled={!thirdTransactionEditable}
                        className="input-box"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Payment UTR</strong></td>
                    <td>
                      <input
                        type="text"
                        value={paymentFormValues.third_transaction_utr ?? invoiceDetails?.third_transaction_utr ?? ''}
                        onChange={(e) => handleInputChange('third_transaction_utr', e.target.value)}
                        disabled={!thirdTransactionEditable}
                        className="input-box"
                      />
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
          {
            balanceAmount > 0 && invoiceDetails?.invoice_status === 'APPROVED' && (
              <div className="button-container">
                <button
                  className="submit-button"
                  onClick={handlePaymentSubmit}
                  disabled={isUpdateButtonDisabled()}
                >
                  Update Payment Details
                </button>
              </div>
            )
          }
        </div>
      </>
    );
  };
  const [payments, setPayments] = useState([]);
  // console.log('payments', dhkhdkhgkdks)
  const [currentPaymentIndex, setCurrentPaymentIndex] = useState(0);
  const [initialBalance, setInitialBalance] = useState(0);
  const [approvalStatus, setApprovalStatus] = useState([]);
  const [showApprovalStatus, setShowApprovalStatus] = useState(false)
  const updatePaymentDetails = (paymentDetails) => {
    setPayments(prev => [...prev, paymentDetails]);
    calculateRemainingBalance();
  };
  const calculateRemainingBalance = () => {
    const totalPaid = payments.reduce((sum, payment) => sum + parseFloat(payment.amount || 0), 0);
    const currentBalance = parseFloat(initialBalance) - totalPaid;

    setInvoiceDetails(prev => ({
      ...prev,
      balance_amt: currentBalance.toFixed(2)
    }));

    return currentBalance;
  };
  function getLableFromID(dropdownArray, label) {
    // Find the item in the dropdown array that matches the given label

    const item = dropdownArray?.find(option => option.value === label);

    console.log(dropdownArray, label, ' label from id >>>>>>>>>>>>>>>>>>>>')

    // Return the value (id) if the item is found, else return null or an appropriate message
    return item ? item.label : null;
  }
  const GetInvoiceDetails = async () => {
    try {
      const response = await makeApiCall(Api_Endpoints.INVOICE_DETAILS, 'POST', { invoice_id: InvoiceID });

      if (response?.status) {
        const details = response.result.data?.invoice_details;
        console.log('Invoice Details:', details);
        const approvalRole = response.result.data?.roles
        console.log('roles99999:', approvalRole);
        setShowApproval(approvalRole);
        const approval = response.result.data?.showAction;
        setShowApprovalStatus(approval);
        console.log('9898998656546:', approval);
        setInvoiceDetails(details);
        const approvedCount = [
          details.invoice_attachment1_approved,
          details.invoice_attachment2_approved,
          details.invoice_attachment3_approved
        ].filter(status => status === "APPROVED").length;

        setApprovedDoc(approvedCount);
        const initialStatuses = {
          invoice_attachment1: details.invoice_attachment1_approved || "PENDING",
          invoice_attachment2: details.invoice_attachment2_approved || "PENDING",
          invoice_attachment3: details.invoice_attachment3_approved || "PENDING"
        };

        const roles = response.result.data?.roles;

        const showAction = response.result.data?.showAction;

        if (roles && details) {
          const approvalData = roles.map(role => ({

            name: role.name.charAt(0).toUpperCase() + role.name.slice(1), // Capitalize first letter
            email: role.email,
            // status: details.invoice_status === 1 ? 'Approved' : details.invoice_status === 2 ? 'Refer-Back' : 'Pending', 
            status: details.invoice_status,
            date: details.updated_at || details.created_at
          }));
          setApprovalStatus(approvalData);
          setShowApprovalStatus(showAction);
        }
        // Sync payment fields with first transaction fields if payment exists but first transaction is null
        const syncedDetails = {
          ...details,
          // Only sync if there's a payment but no first transaction
          first_transaction_amt: details.first_transaction_amt || (parseFloat(details.payment_amt) > 0 ? details.payment_amt : null),
          first_transaction_date: details.first_transaction_date || (details.payment_date ? details.payment_date : null),
          first_transaction_utr: details.first_transaction_utr || (details.payment_utr ? details.payment_utr : null)
        };

        // Update installment transaction visibility
        if (parseFloat(syncedDetails.payment_amt) > 0 && parseFloat(syncedDetails.balance_amt) > 0) {
          setShowInstallmentTransaction({
            ...showInstallmentTransaction,
            firstTransaction: true
          });
        }

        if (parseFloat(syncedDetails.first_transaction_amt) > 0 && parseFloat(syncedDetails.balance_amt) > 0) {
          setShowInstallmentTransaction({
            ...showInstallmentTransaction,
            secondTransaction: true
          });
        }

        if ((parseFloat(syncedDetails.second_transaction_amt) > 0 && parseFloat(syncedDetails.balance_amt) > 0) ||
          parseFloat(syncedDetails.third_transaction_amt) > 0) {
          setShowInstallmentTransaction({
            ...showInstallmentTransaction,
            thirdTransaction: true
          });
        }

        const mappedDetails = {
          ...syncedDetails,
          gst_no: syncedDetails.gst_no,
          pan_no: syncedDetails.pan_no,
          gst_rate: syncedDetails.gst_rate || syncedDetails.gst_rate,
        };

        setInvoiceDetails(mappedDetails);
        setInitialBalance(parseFloat(mappedDetails.net_payable) || 0);

        if (details.payments && Array.isArray(details.payments)) {
          setPayments(details.payments);
          setCurrentPaymentIndex(details.payments.length);
        }

        if (mappedDetails?.net_amt) {
          calculateAmounts(
            mappedDetails.net_amt,
            mappedDetails.gst_no,
            mappedDetails.gst_rate,
            mappedDetails.tds_rate
          );
        }
        setDocumentStatuses(initialStatuses);
      } else {
        showErrorToast(response?.message);
      }
    } catch (error) {
      console.error('Error fetching invoice details:', error);
      showErrorToast('Failed to fetch invoice details');
    }

  };

  const getDepartmentDropDown = async (
  ) => {
    const res = await makeApiCall(Api_Endpoints.DASHBOARD_DROPDOWN, "GET",)
    if (res?.status) {
      setVendorDropDown(res?.data.vendor)
      setInvoiceDropDown(res?.data.invoice)
      setDepartmentOptions(res?.data?.vendor.department || []);
      setAuthorizedPersonOptions(res?.data?.vendor.department_data || []);
    }
  }
  const [isUpdate, setIsUpdate] = useState(false)
  useEffect(() => {
    if (InvoiceID) {
      GetInvoiceDetails();
      setIsUpdate(true)
    }
    getDepartmentDropDown()
  }, [])

  const GetVendorDetails = async () => {
    const response = await makeApiCall(Api_Endpoints.VENDOR_DETAILS, 'POST', { vendor_id: vendorID });

    if (response?.status) {
      const details = response.result?.vendor_details;
      console.log('Vendor Details:', details?.tds_rate);
      setVendorDetails(response.result?.vendor_details);

      // Map the data with correct property names
      const mappedDetails = {
        ...details,
        gst_no: details.gst_no,
        pan_no: details.pan_no,
        gst_rate: details.gst_rate,
        tds_rate: details.tds_rate
      };

      setInvoiceDetails(mappedDetails);

      if (mappedDetails?.net_amt) {
        calculateAmounts(
          mappedDetails.net_amt,
          mappedDetails.gst_no,
          mappedDetails.gst_rate,
          mappedDetails.tds_rate
        );
      }
    } else {
      showErrorToast(response?.message);
    }
  };

  const isUpdateMode = Boolean(InvoiceID);
  const handleSubmit = async () => {
    try {
      // Validate required fields
      if (!invoiceDetails.invoice_number) {
        showErrorToast('Invoice number is required');
        return;
      }
      if (!invoiceDetails.invoice_date) {
        showErrorToast('Invoice date is required');
        return;
      }

      if (!invoiceDetails.net_amt) {
        showErrorToast('Net amount is required');
        return;
      }
      if (!invoiceDetails.business_month) {
        showErrorToast('Business month is required');
        return;
      }




      const payload = {
        vendor_id: invoiceDetails.vendor_id || vendorDetails.vendor_id || vendorID,
        invoicing_company: 'Indicosmic Infotech Ltd',
        business_month: invoiceDetails.business_month,
        business_year: invoiceDetails.business_year,
        name: invoiceDetails.name || vendorDetails.name || '',
        department: invoiceDetails.department,
        department_data: invoiceDetails.department_data,
        // Match the exact property names from API response
        gst_no: invoiceDetails.gst_no || vendorDetails.gst_no || '',
        pan_no: invoiceDetails.pan_no || vendorDetails.pan_no || '',
        invoice_date: invoiceDetails.invoice_date,
        invoice_number: invoiceDetails.invoice_number,
        nature_of_business: invoiceDetails.nature_of_business || vendorDetails.nature_of_business,
        net_amt: parseFloat(invoiceDetails.net_amt) || 0,
        gst_rate: parseFloat(invoiceDetails.gst_rate) || parseFloat(vendorDetails.gst_rate) || 0,
        gst_amount: parseFloat(invoiceDetails.gst_amount) || 0,
        igst: parseFloat(invoiceDetails.igst) || 0,
        cgst: parseFloat(invoiceDetails.cgst) || 0,
        sgst: parseFloat(invoiceDetails.sgst) || 0,
        total: parseFloat(invoiceDetails.total) || 0,
        tds_rate: parseFloat(invoiceDetails.tds_rate) || parseFloat(vendorDetails.tds_rate) || 0,
        tds_amt: parseFloat(invoiceDetails.tds_amt) || 0,
        net_of_tds: parseFloat(invoiceDetails.net_payable) || 0,
        net_payable: parseFloat(invoiceDetails.net_payable) || 0,

        payment_mode: 'Online' || '',
        invoice_attachment1: attachmentFiles.url_attachment1 || '',
        invoice_attachment2: attachmentFiles.url_attachment2 || '',
        invoice_attachment3: attachmentFiles.url_attachment3 || '',

        payment_amt: payments.payment_amt || 0,
        first_transaction_amt: payments.first_transaction_amt || 0,
        first_transaction_date: payments.first_transaction_date || null,
        first_transaction_utr: payments.first_transaction_utr || null,
        second_transaction_amt: payments.second_transaction_amt || 0,
        second_transaction_date: payments.second_transaction_date || null,
        second_transaction_utr: payments.second_transaction_utr || null,
        third_transaction_amt: payments.third_transaction_amt || 0,
        third_transaction_date: payments.third_transaction_date || null,
        third_transaction_utr: payments.third_transaction_utr || null
      };

      if (user_data?.user === 'Finance') {
        Object.assign(payload, {
          payment_utr: invoiceDetails.payment_utr,
          payment_date: invoiceDetails.payment_date,
          payment_amt: parseFloat(invoiceDetails.payment_amt) || 0,
          payment_status: invoiceDetails.payment_status,
        });
      }

      if (isUpdateMode) {
        payload.invoice_id = InvoiceID;
      }

      const endpoint = isUpdateMode ? Api_Endpoints.INVOICE_ADD : Api_Endpoints.INVOICE_ADD;
      const response = await makeApiCall(
        endpoint,
        "POST",
        payload
      );

      if (response?.status) {
        showSuccessToast(`Invoice ${isUpdateMode ? 'updated' : 'submitted'} successfully`);
        navigate('/InvoiceList');
      } else {
        if (response?.result && Array.isArray(response.result)) {
          response.result.forEach(error => showErrorToast(error));
        } else {
          showErrorToast(response?.message || `Failed to ${isUpdateMode ? 'update' : 'submit'} invoice`);
        }
      }
    } catch (error) {
      console.error('Error handling invoice:', error);
      showErrorToast(`An error occurred while ${isUpdateMode ? 'updating' : 'submitting'} the invoice`);
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState('');

  const openModal = (url, documentType) => {
    window.open(url);
    // setSelectedImageUrl(url);
    setIsModalOpen(false);
    setViewedDocuments((prev) => new Set([...prev, documentType]));
  };


  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImageUrl('');
  };


  const [documentStatuses, setDocumentStatuses] = useState({
    url_invoice_attachment1: null,
    url_invoice_attachment2: null,
    url_invoice_attachment3: null
  });

  const handleDocumentStatusUpdate = (documentKey, status) => {
    setDocumentStatuses(prev => ({
      ...prev,
      [documentKey]: status
    }));
  };

  const handleDocumentApproval = (documentNumber) => {
    const documentKey = `url_invoice_attachment${documentNumber}`;
    handleDocumentStatusUpdate(documentKey, 'APPROVED');
  };

  const approveDocument = (documentType, statusField) => {
    setDocumentStatuses((prev) => ({
      ...prev,
      [documentType]: "APPROVED"
    }));
    setInvoiceDetails((prev) => ({
      ...prev,
      [statusField]: "APPROVED"
    }))
  };

  const rejectDocument = (documentType, statusField) => {
    setDocumentStatuses((prev) => ({
      ...prev,
      [documentType]: "Rejected"
    }));
    setInvoiceDetails((prev) => ({
      ...prev,
      [statusField]: "Rejected"
    }))
  };
  const [viewedDocuments, setViewedDocuments] = useState(() => {
    const savedViewed = localStorage.getItem(`viewedDocuments-${InvoiceID}`);
    return new Set(savedViewed ? JSON.parse(savedViewed) : []);
  });

  const [details, setDetails] = useState([]);
  const DocumentRow = ({ label, url, filename, documentType, status }) => {
    const documentStatus = invoiceDetails[`${documentType}_approved`] || "PENDING";

    return (
      <tr>
        <td><strong>{label}</strong></td>
        <td className="flex items-start gap-2">
          {url && filename ? (
            <span
              onClick={() => openModal(url, documentType)}
              className="hover:text-blue-600 cursor-pointer"
              style={{ cursor: "pointer", color: "blue" }}
            >
              {filename}
            </span>
          ) : (
            <p>NA</p>
          )}
        </td>
        {url && filename && user_data?.user !== 'Account' && (
          <>
            <td className="flex items-center gap-4">
              <CheckCircle
                style={{
                  width: "1.25rem",
                  height: "1.25rem",
                  cursor: viewedDocuments.has(documentType) ? "pointer" : "not-allowed",
                  color: documentStatus === "APPROVED" ? "green" : "blue",
                }}
                onClick={() =>
                  viewedDocuments.has(documentType)
                    ? approveDocument(documentType, `${documentType}_approved`)
                    : showErrorToast("Please View Document")
                }
              />
              <XCircle
                style={{
                  width: "1.25rem",
                  height: "1.25rem",
                  cursor: viewedDocuments.has(documentType) ? "pointer" : "not-allowed",
                  color: documentStatus === "Rejected" ? "red" : "blue",
                }}
                onClick={() =>
                  viewedDocuments.has(documentType)
                    ? rejectDocument(documentType, `${documentType}_approved`)
                    : null
                }
              />
            </td>
            <td>
              <span
                style={{
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  color: documentStatus === "APPROVED" ? "green"
                    : documentStatus === "Rejected" ? "red"
                      : "blue",
                }}
              >
                {documentStatus}
              </span>
            </td>
          </>
        )}
      </tr>
    );
  };
  const keysToVerify = [
    "url_invoice_attachment1",
    "url_invoice_attachment2",
    "url_invoice_attachment3",

  ];

  const getStatusIcon = (status) => {
    switch (status.toLowerCase()) {
      case 'approved':
        return <CheckCircle className="h-5 w-5 text-green-500 CheckCircle" />;
      case 'refer-back':
        return <XCircle className="h-5 w-5 text-red-500 XCircle" />;
      case 'pending':
        return <Clock className="h-5 w-5 text-yellow-500 Clock" />;
      default:
        return <Clock className="h-5 w-5 text-yellow-500 Clock" />;
    }
  };
  useEffect(() => {
    if (invoiceDetails) {
      const filteredObject = {};

      // Filter the details object only if it's not empty or null
      keysToVerify.forEach((key) => {
        if (invoiceDetails[key] !== "" && invoiceDetails[key] !== null && invoiceDetails[key] !== undefined) {
          filteredObject[key] = invoiceDetails[key];
        }
      });

      // Only set the filtered documents if the object is different from the previous one
      setGetDocument(filteredObject);
      console.log(filteredObject, "filtered document")
      console.log(ApprovedDoc, "fetched document list >>>>>>>>>>.")
      console.log(Object.keys(filteredObject).length, "lengths sssssssssssss");
      setGetDocument(Object.keys(filteredObject).length);
    }
  }, [invoiceDetails])
  useEffect(() => {
    if (InvoiceID) {
      GetInvoiceDetails();
    }

    if (vendorID) {
      GetVendorDetails();
    }
  }, [InvoiceID, vendorID]);
  useEffect(() => {
    localStorage.setItem(`documentStatuses-${InvoiceID}`, JSON.stringify(documentStatuses));
  }, [documentStatuses, InvoiceID]);

  useEffect(() => {
    localStorage.setItem(`viewedDocuments-${InvoiceID}`, JSON.stringify([...viewedDocuments]));
  }, [viewedDocuments, InvoiceID]);
  useEffect(() => {
    // Disable if the values are not equal or if both are zero
    const condition = ApprovedDoc !== getDocument || (ApprovedDoc === 0 && getDocument === 0);
    setCount(condition); // Update the state to reflect the disabled condition
  }, [getDocument, ApprovedDoc]);
  useEffect(() => {
    checkAllDocumentsStatus();
  }, [documentStatuses, viewedDocuments]);
  useEffect(() => {
    const documentCount = Object.keys(invoiceDetails).filter(key =>
      key.startsWith('url_invoice_attachment') && invoiceDetails[key]
    ).length;
    setGetDocument(documentCount);
  }, [invoiceDetails]);


  const downloadPDF = () => {
    if (false) {
      alert('Please Accept terms and Condition');
    } else {
      const printContents = document.querySelector('.invoice-page').innerHTML;
      const printWindow = window.open('', 'Invoice Report', 'height=800,width=800');

      printWindow.document.write('<html><head><title>Invoice Report</title>');
      printWindow.document.write('<style>');
      printWindow.document.write(`
        body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
        .invoice-page { width: 100%; padding: 20px; }
        .invoice-title { font-size: 30px; font-weight: bold; text-align: center; margin-bottom: 20px; }
        .invoice-section { margin-bottom: 20px; }
        .invoice-table { width: 100%; border-collapse: collapse; font-size: 18px; margin-bottom: 20px; }
        .invoice-table th, .invoice-table td { border: 1px solid #000; padding: 10px; text-align: left; }
        .invoice-table td { font-size: 18px; }
        .page-break { page-break-before: always; margin-top: 20px; }
        .footer { position: fixed; bottom: 0; left: 0; width: 100%; background-color: #f0f0f0; padding: 10px; text-align: center; border-top: 1px solid #ccc; }
        .footer p { font-size: 14px; margin: 0; padding: 0; }
        @media print {
          @page { size: A4; margin: 20mm; }
          body { font-size: 16px; }
          .invoice-title { font-size: 24px; text-align: center; }
          .invoice-table { font-size: 18px; }
          .footer { position: fixed; bottom: 0; width: 100%; }
          .invoice-table th, .invoice-table td { page-break-inside: avoid; }
        }
      `);

      printWindow.document.write('</style></head><body>');
      printWindow.document.write('<div class="invoice-page">');
      printWindow.document.write(printContents);
      printWindow.document.write('</div>');
      printWindow.document.write(`
        <div class="footer">
          <p>Invoice Date: ${new Date().toLocaleDateString()}</p>
        </div>
      `);
      printWindow.document.write('</body></html>');
      printWindow.document.close();

      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
    }
  };

  return (
    <div id='invoice-content' className="invoice-page">
      <header className="invoice-header">
        <div className="header-title">
          <h1>{invoiceDetails?.name || vendorDetails?.name || 'Vendor Name'}</h1>
        </div>
      </header>
      <h1 className="invoice-title">Invoice Details</h1>
      <div className="invoice-section">
        <table className="invoice-table">
          <tbody>
            <tr>
              <td><strong>Invoice Number</strong></td>
              <td>
                <input
                  type='text'
                  placeholder='Enter Invoice Number'
                  className='input-box'
                  value={invoiceDetails?.invoice_number || ''}
                  onChange={(e) => handleInputChange('invoice_number', e.target.value)}
                  readOnly={isUpdateMode}
                />
              </td>
              <td><strong>Invoice Date</strong></td>
              <td>
                <input
                  type='date'
                  placeholder='Enter Invoice Date'
                  className='input-box'
                  value={invoiceDetails?.invoice_date || ''}
                  onChange={(e) => handleInputChange('invoice_date', e.target.value)}
                  readOnly={isUpdateMode}
                  max={new Date().toISOString().split('T')[0]}
                />
              </td>
            </tr>
            <tr>
              <td><strong>Vendor Name</strong></td>
              <td>{invoiceDetails?.name || vendorDetails?.name || ''}</td>
              <td><strong>Invoicing Company:</strong></td>
              <td>
                {!true ? (
                  <select
                    className="input-box-dropdown"
                    value={invoiceDetails?.invoicing_company}
                    onChange={(e) => handleInvoiceCompanyChange(e.target.value)}
                  >
                    <option value="">Select Company</option>
                    <option value="Indicosmic Infotech Ltd">Indicosmic Infotech Ltd</option>
                    {/* <option value="GIIB India Ltd">GIIB India Ltd</option> */}
                  </select>
                ) : (
                  <span>INDICOSMIC INFOTECH LTD</span>
                )}
              </td>
            </tr>
            <tr>
              <td><strong>Nature of Business</strong></td>
              <td>{invoiceDetails?.nature_of_business || vendorDetails.nature_of_business}</td>
              <td><strong>Payment Mode:</strong></td>
              {/* <td>
              <span>{invoiceDetails?.payment_mode || "Online"}</span>
            </td> */}
              <td>
                {!true ? (
                  <select
                    className="input-box-dropdown"
                    value={invoiceDetails?.payment_mode}
                    onChange={(e) => handleInvoicePaymentModeChange(e.target.value)}
                  >
                    <option value="">Select Mode</option>
                    <option value="Online">Online</option>
                    <option value="Offline">Offline</option>
                  </select>
                ) : (
                  <span>ONLINE</span>
                )}
              </td>
            </tr>


            {user_data?.user === 'Account' && vendorDetails?.vendor_category === 'Tactical' && (

              <tr>
                <td><strong>Department</strong></td>
                <td>
                  {!isUpdateMode ? (
                    <select
                      className="input-box-dropdown"
                      value={invoiceDetails?.department || ''}
                      onChange={(e) => handleDepartmentChange(e.target.value)}
                    >
                      <option value="">Select Department</option>
                      {departmentOptions.map(dept => (
                        <option key={dept.value} value={dept.value}>
                          {dept.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span>{getLableFromID(departmentOptions, invoiceDetails?.department)}</span>
                  )}
                </td>
                <td><strong>Authorized Person</strong></td>
                <td>
                  {!isUpdateMode ? (
                    <select
                      className="input-box-dropdown"
                      value={invoiceDetails?.department_data || ''}
                      onChange={(e) => handleAuthorizedPersonChange(e.target.value)}
                      disabled={!invoiceDetails?.department} // Disable if no department selected
                    >
                      {/* <option value="">Select Authorized Person</option> */}
                      {filteredAuthorizedPersons.map(person => (
                        <option key={person.value} value={person.value}>
                          {person.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span>{getLableFromID(authorizedPersonOptions, invoiceDetails?.department_data)}</span>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>



      <div>
        <h2 className="invoice-subtitle">Financial Details</h2>
        <div className="invoice-section">
          <table className="invoice-table">
            <tbody>
              <tr>
                <td><strong>Net Amount</strong></td>
                <td>
                  {isEditable ? (
                    <input
                      type="number"
                      value={invoiceDetails?.net_amt || ''}
                      onChange={handleNetAmountChange}
                      placeholder="Enter Net Amount"
                      className="input-box"
                    />
                  ) : (
                    <CurrencyFormat
                      value={invoiceDetails?.net_amt || '0.00'}
                      displayType={'text'}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  )}
                </td>
                <td><strong>IGST</strong></td>
                <td>
                  <CurrencyFormat
                    value={invoiceDetails?.igst || '0.00'}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </td>
              </tr>
              <tr>
                <td><strong>CGST</strong></td>
                <td>
                  <CurrencyFormat
                    value={invoiceDetails?.cgst || '0.00'}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </td>
                <td><strong>SGST</strong></td>
                <td>
                  <CurrencyFormat
                    value={invoiceDetails?.sgst || '0.00'}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </td>
              </tr>
              <tr>
                <td><strong>Total Invoice Value</strong></td>
                <td>
                  <CurrencyFormat
                    value={invoiceDetails?.total}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </td>
                <td><strong>Net Payable</strong></td>
                <td>
                  <CurrencyFormat
                    value={invoiceDetails?.net_payable || '0.00'}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </td>
              </tr>
              <tr>
                <td><strong>TDS Amount</strong></td>
                <td>
                  <CurrencyFormat
                    value={invoiceDetails?.tds_amt || '0.00'}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </td>
                <td><strong>TDS Rate</strong></td>

                <td>{invoiceDetails?.tds_rate || '0.00'}</td>
              </tr>
              <tr>
                <td><strong>GST Amount</strong></td>
                <td>
                  <CurrencyFormat
                    value={invoiceDetails?.gst_amount || '0.00'}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </td>
                <td><strong>GST Rate</strong></td>

                <td>{invoiceDetails?.gst_rate || '0.00'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* {user_data?.user === 'Finance' && <PaymentSection />} */}

      {renderPaymentSection()}



      <h2 className="invoice-subtitle">Additional Details</h2>
      <div className="invoice-section">
        <table className="invoice-table">
          <tbody>
            <tr>
              <td><strong>Business Month</strong></td>
              <td>
                <input
                  type="month"
                  value={formatMonthValue()}
                  className="input-box"
                  onChange={(e) => handleInputChange('business_month', e.target.value)}
                  max={new Date().toISOString().slice(0, 7)}
                />
              </td>
              <td><strong>Comments</strong></td>
              <td>{invoiceDetails?.comments || 'N/A'}</td>

            </tr>
            <tr>
              <td><strong>PAN Number</strong></td>
              <td>{invoiceDetails?.pan_no || vendorDetails?.pan_no}</td>
              <td><strong>GST Number</strong></td>
              <td>{invoiceDetails?.gst_no || vendorDetails?.gst_no}</td>
            </tr>

          </tbody>
        </table>
      </div>

      {(user_data?.user === 'Finance' && showApproval && Object.keys(showApproval).length !== 0) && (
        <>
          <h2 className="invoice-subtitle mb-4">Approval Status</h2>
          <div className="invoice-section">
            <table className="invoice-table">
              <tbody>
                <tr>
                  <td><strong>Name</strong></td>
                  <td><strong>Status</strong></td>
                  <td><strong>Date</strong></td>
                  <td><strong>Email</strong></td>
                </tr>
                {approvalStatus.map((item, index) => (

                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>
                      <div className="flex items-center gap-2 approval-status">
                        {getStatusIcon(item.status)}
                        <span className={`status-text ${item.status === 'APPROVED' ? 'status-approved' :
                          item.status === 'REFER-BACK' ? 'status-referred' :
                            'status-pending'
                          }`}>
                          {item.status}
                        </span>
                      </div>
                    </td>
                    <td>{new Date(item.date).toLocaleDateString()}</td>
                    <td>{item.email}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      <div className="invoice-actions">
        {(user_data?.user === 'Account') && (
          <button onClick={downloadPDF} className="download-button">
            Download PDF
          </button>
        )}
      </div>

      <div className="invoice-section">
        {(user_data?.user === 'Account') && (
          <div>
            <h2 className="invoice-subtitle">Attachments</h2>
            <div className='TextInputRow'>
              <FileUpload
                label="Upload Invoice Document"
                onChange={(e) => handleFileChange(e, 'url_attachment1')}
                value={invoiceDetails.url_attachment1}
                error={formErrors.url_attachment1}
                required={true}
                accept=".jpg, .jpeg, .png, .pdf"
                multiple={false}
                note="Only PDF, JPG, JPEG, and PNG files are allowed."
              />

            </div>
            <div className='TextInputRow'>
              <FileUpload
                label="Upload Document1"
                onChange={(e) => handleFileChange(e, 'url_attachment2')}
                value={invoiceDetails.url_attachment2}
                // error={formErrors.url_attachment1}
                required={false}
                accept=".jpg, .jpeg, .png, .pdf"
                multiple={false}
                note="Only PDF, JPG, JPEG, and PNG files are allowed."
              />

            </div>
            <div className='TextInputRow'>
              <FileUpload
                label="Upload Document2"
                onChange={(e) => handleFileChange(e, 'url_attachment3')}
                value={invoiceDetails.url_attachment3}
                // error={formErrors.url_attachment1}
                required={false}
                accept=".jpg, .jpeg, .png, .pdf"
                multiple={false}
                note="Only PDF, JPG, JPEG, and PNG files are allowed."
              />

            </div>
          </div>
        )}

        {user_data?.user !== 'Account' && (
          <div className="report-section">
            <h2>Attached Documents</h2>
            <table className="data-table vendor-documents">
              <tbody>
                <DocumentRow
                  label="Attached Documents 1"
                  url={invoiceDetails?.url_invoice_attachment1}
                  filename={invoiceDetails?.invoice_attachment1}
                  documentType="invoice_attachment1"
                  status="invoice_attachment1_approved"
                />
                <DocumentRow
                  label="Attached Documents 2"
                  url={invoiceDetails?.url_invoice_attachment2}
                  filename={invoiceDetails?.invoice_attachment2}
                  documentType="invoice_attachment2"
                  status="invoice_attachment2_approved"
                />
                <DocumentRow
                  label="Attached Documents 3"
                  url={invoiceDetails?.url_invoice_attachment3}
                  filename={invoiceDetails?.invoice_attachment3}
                  documentType="invoice_attachment3"
                  status="invoice_attachment3_approved"
                />




              </tbody>
            </table>
          </div>
        )}

        <ImageModal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          imageUrl={selectedImageUrl}
        />

        {(user_data?.user === 'Finance' || user_data?.user === 'Account') &&
          <div className='SubmitButton'>
            <button
              className="Approved-button"
              onClick={handleSubmit}
              disabled={invoiceDetails?.invoice_status === "PENDING" ||
                !invoiceDetails?.invoice_number ||
                !invoiceDetails?.invoice_date ||
                !invoiceDetails?.net_amt ||
                !invoiceDetails?.business_month
              }
            >
              {isUpdateMode ? 'Update' : 'Submit'}
            </button>
          </div>}
        {console.log(user_data?.user, user_data?.user !== 'Account', invoiceDetails?.invoice_status === 'PENDING', invoiceDetails?.invoice_status, showApprovalStatus)}

        {console.log('ujui', user_data?.user !== 'Account' && invoiceDetails?.invoice_status === 'PENDING' && showApprovalStatus)}
        {(user_data?.user !== 'Account' && invoiceDetails?.invoice_status === 'PENDING' && showApprovalStatus) && (
          <div>
            {invoiceDetails.invoice_status !== 'APPROVED' && (
              <div className="button-status">
                <button
                  className="Approved-button"
                  disabled={count}
                  // disabled={!checkAllDocumentsViewed()}
                  // disabled={!checkAllDocumentsStatus()}
                  onClick={() => handleModal('APPROVED')}
                >
                  Approve
                </button>
                <button
                  className="Reffered-button"
                  disabled={viewedDocuments.size === 0}
                  onClick={() => handleModal('REFER-BACK')}
                >
                  Refer-Back
                </button>
              </div>
            )}
          </div>
        )}


        <CommentModal
          isOpen={commentModalOpen}
          onClose={() => {
            setCommentModalOpen(false);
            // setShowConfirmation(false);
          }}
          onSubmit={(adminComment) => handleActionClick(adminComment)}
        />
        {showConfirmation && (
          <div className="confirmation-dialog">
            <div className="confirmation-content">
              <p>
                {status === 'APPROVED'
                  ? 'Are you sure you want to approve?'
                  : 'Are you sure you want to refer back?'}
              </p>
              <button onClick={() => handleConfirmAction()}>Yes</button>
              <button onClick={() => setShowConfirmation(false)}>No </button>
            </div>
          </div>
        )}
      </div>

    </div>
  );
};




export default InvoiceViewPage;